import {createContext, useContext} from "react";

export type OpenFilterCarouselContextType = {
    openFilterCarousel: string;
    setOpenFilterCarousel: (openFilterCarousel: string) => void;
};

export const OpenFilterCarouselContext = createContext<OpenFilterCarouselContextType>({
    openFilterCarousel: "",
    setOpenFilterCarousel: () => {
    },
});

export const useOpenFilterCarousel = () => useContext(OpenFilterCarouselContext);
